export default axios => ({
  // Sprachnachricht (AudioNachricht.vue): kurzlebige S3-URLs (5 Min) der aktiven Version, nicht cachen.
  // key = umschuldung-plus1-consors-ab | consors-10500-genehmigt; 404 = keine aktive Version
  nachricht (key) {
    return axios.get(`/customer/audio/${key}`).then(({ data }) => data.quellen)
  }
})
